import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { getImageSRC } from "../../functions/assets";

const Logo = ({ logo }) => {
  const src = getImageSRC(logo && logo.filename);
  const alt = (logo && logo.name) || "Logo";
  const [loaded, setLoaded] = useState(false);

  // reset loading state when source changes
  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return (
    <Box
      sx={{
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "15px",
        marginBottom: "20px",
        minHeight: "100px",
        maxHeight: "150px",
        width: "100%",
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        sx={{
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          // Fade the image in when it's loaded. Keep it rendered (opacity 0)
          // so the browser can download it while the Skeleton is shown.
          opacity: loaded ? 1 : 0,
          transition: "opacity 350ms ease-in-out",
          willChange: "opacity",
          // Allow the image to scale to the container's width or height while
          // preserving aspect ratio. When the container limits height, the
          // image will shrink to fit; otherwise it will fill width.
          maxWidth: "100%",
          maxHeight: "150px",
          width: "auto",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default Logo;
